module.exports = __webpack_public_path__ + "static/img/Frame16.beb8a9f2.png";